import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowDropdown = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 8, height: 6, viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M8 1.92L6.76118 0.666666L3.99564 3.48444L1.2301 0.666667L1.20152e-07 1.92L3.99564 6L8 1.92Z", fill: "currentColor" }) });
const ForwardRef = forwardRef(SvgArrowDropdown);
export { ForwardRef as ReactComponent };
